import React from "react";
import * as c from "./lcArticleCalloutBlock.module.scss";
import classNames from "classnames";
import { IconCalloutInfo } from "@components/icons/iconCalloutInfo";
import { IconCalloutWarning } from "@components/icons/iconCalloutWarning";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { createRichTextOptions } from "@components/shared/richTextOptions";

export default function LcArticleCalloutBlock({ calloutType, richTextDescription }) {
  if (!richTextDescription) {
    return null;
  }

  const calloutPresets = {
    Info: {
      class: "info",
      className: "info",
      CalloutIcon: IconCalloutInfo,
      label: "Note",
    },
    Warning: {
      class: "warning",
      className: "warning",
      CalloutIcon: IconCalloutWarning,
      label: "Important",
    },
  };

  const callout = calloutPresets?.[calloutType] || calloutPresets.Info;

  return (
    <>
      {(({ CalloutIcon, className, label }) => (
        <div className={classNames(c.container, c[className])}>
          <CalloutIcon className={c.icon} />
          <div className={c.text}>
            <strong className={c.label}>{label}:&nbsp;</strong>
            {renderRichText(richTextDescription, createRichTextOptions())}
          </div>
        </div>
      ))(callout)}
    </>
  );
}
